module.exports = require('./AuditLogView');
